import { request, errHandler } from "./heimdall";
import store from "../store";

export function getProviders() {
  return request
    .get("/providers", {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getProvider(id) {
  return request
    .get(`/providers/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}
